import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTreeMapInfo = async (HubIds: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.laborDemandPulse.getTreeMapInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, Locations, fromQuarter, toQuarter, isEntryLevel },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
